import { render, staticRenderFns } from "./approveText.vue?vue&type=template&id=ff21f348&scoped=true"
import script from "./approveText.vue?vue&type=script&lang=js"
export * from "./approveText.vue?vue&type=script&lang=js"
import style0 from "./approveText.vue?vue&type=style&index=0&id=ff21f348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff21f348",
  null
  
)

export default component.exports